import React from "react";
import { Modal } from "@toddle-edu/ds-web";
import AIVoiceContainer from "AppComponents/ConfigureAIVoice/components/ConfigureAIVoiceV3/components/AIVoiceContainer/AIVoiceContainer.js";

const ConfigureAIVoiceV3 = props => {
  const {
    isVoiceModalOpen,
    closeVoiceModal,
    selectedAIVoiceTone,
    promptSetEntityType,
    courseId,
    handleWandClick,
    isGenerateCommandDisabled,
  } = props;

  return (
    <Modal
      width="1032px"
      height="760px"
      isOpen={isVoiceModalOpen}
      onClose={closeVoiceModal}
    >
      <AIVoiceContainer
        closeVoiceModal={closeVoiceModal}
        selectedAIVoiceTone={selectedAIVoiceTone}
        promptSetEntityType={promptSetEntityType}
        courseId={courseId}
        handleWandClick={handleWandClick}
        isGenerateCommandDisabled={isGenerateCommandDisabled}
      />
    </Modal>
  );
};

export default ConfigureAIVoiceV3;
